export interface ApiSuccess<T> {
  success: true;
  data: T;
}

export interface ApiError {
  success: false;
  error: string;
}

export type ApiResponse<T> = ApiSuccess<T> | ApiError;

export const tryCatcher = async <T>(func: () => Promise<T>): Promise<ApiResponse<T>> => {
  try {
    const data = await func();
    return { success: true, data };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return { success: false, error: e.message };
  }
};

export default { tryCatcher };
